import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';

export type 确认类型 = '信息' | '成功' | '警告' | '错误';

export class 确认 {
    constructor(
        内容: string[],
        类型: 确认类型 = '信息',
        标题 = '确认',
        确认文本 = '确定',
        取消文本 = '取消'
    ) {
        this.类型 = 类型;
        this.内容 = 内容;
        this.标题 = 标题;
        this.确认文本 = 确认文本;
        this.取消文本 = 取消文本;
        this.promise = new Promise<boolean>((resolve) => {
            this.resolve = resolve;
        });
    }

    类型: 确认类型;
    标题: string;
    确认文本: string;
    取消文本: string;
    内容: string[];
    promise: Promise<boolean>;
    resolve!: (value: PromiseLike<boolean> | boolean) => void;
}

@Module({
    name: 'ConfirmState',
    dynamic: true,
    namespaced: true,
    store: store,
})
export default class ConfirmState extends VuexModule {
    确认: 确认 | null = null;

    @Mutation
    改变确认(确认: 确认 | null) {
        this.确认 = 确认;
    }

    @Action
    async 开始确认(确认: 确认) {
        this.改变确认(确认);
        await 确认.promise;
        this.改变确认(null);
        return 确认.promise;
    }
}

export const 确认状态 = getModule(ConfirmState);
